import {
  getTableData,
  saveCompetitor,
  getCompetitorDetail,
  updateCompetitor,
  getInci,
  getFormulationFunction
} from '@/axios/api/competitor'

const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_INCI = 'UPDATE_INCI'
const UPDATE_FORMULATION_FUNCTION = 'UPDATE_FORMULATION_FUNCTION'

const state = {
  tableData: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  detail: {},
  inciList: [],
  formulationFunction: []
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      // formulationFunction: v.formulationFunctionList && v.formulationFunctionList.length
      //   ? v.formulationFunctionList.map(value => value.functionName).join(',')
      //   : [],
      // inci: v.inciList && v.inciList.length
      //   ? v.inciList.map(value => value.inciName).join(',')
      //   : []
    }
  }),
  pager: state => state.pager,
  detail: state => state.detail,
  inciList: state => state.inciList.map(v => {
    return {
      label: v.inciName,
      value: v.id
    }
  }),
  formulationFunction: state => state.formulationFunction.map(v => {
    return {
      ...v,
      value: v.id,
      label: v.enFormulationFunction
    }
  })
}

const mutations = {
  [UPDATE_TABLE_DATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_INCI] (state, inciList) {
    state.inciList = inciList
  },
  [UPDATE_FORMULATION_FUNCTION] (state, formulationFunction) {
    state.formulationFunction = formulationFunction
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    try {
      const { data: res } = await getTableData(params)
      commit(UPDATE_TABLE_DATA, res.records)
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {}
  },
  // 设置pager
  setPagerApi ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  // 新增
  async addCompetitorApi ({ commit }, params) {
    try {
      await saveCompetitor(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 编辑
  async editCompetitorApi ({ commit }, params) {
    try {
      await updateCompetitor(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 详情
  async getDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getCompetitorDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
  },
  // 获取inci下拉
  async getInciApi ({ commit }, params) {
    try {
      let { data: res } = await getInci(params)
      commit(UPDATE_INCI, res)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取function下拉
  async getFormulationFunctionApi ({ commit }, params) {
    try {
      let { data: res } = await getFormulationFunction(params)
      commit(UPDATE_FORMULATION_FUNCTION, res.records || [])
      return true
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/competitor.js